import { langData, RootState } from "@hypexone/uicore";
import { HeaderProps } from "../../../../utils/types/userMenu.types";
import { connect } from "react-redux";

const UserMenuPageTitle = ({
  title,
  ProfitLoss,
  customBgColor,
  balance,
  exposure
}: HeaderProps) => {
  return (
    <div
      className={`py-1 flex text-[14px] font-[700] flex-row justify-between items-center  w-full text-white px-2 ${
        customBgColor || "bg-black1"
      }`}
    >
      <div>
        <p className="text-[14px]">{title}</p>
      </div>
      {title === langData?.['profit_loss_details'] && (
        <div>
          <p className="text-[14px]">
            Total P/L: IR <span className="text-green-700">{ProfitLoss}</span>
          </p>
        </div>
      )}
      {title === langData?.['my_wallet'] && (
        <div>
          <p className="text-[14px]">
            AVAILABLE BALANCE : <span >{(Number(balance) - Number(exposure))?.toFixed(2)}</span>
          </p>
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state: RootState) => {
  return {
    balance: state.auth.balanceSummary.balance,
    exposure: state.auth.balanceSummary.exposure,
  };
};



export default connect(mapStateToProps, null)(UserMenuPageTitle);

